import styles from './Empty.module.scss';

const Empty = () => {
  return <section className={styles.layout}>저장된 링크가 없습니다</section>;
};

export default Empty;
